const getFullAddress = (values, separators) =>
  values.reduce((acc, value, index) => {
    const separator = separators[index - 1];
    if (value === "" && !separator.includes("\n")) return acc;

    return acc + separator + value;
  });

export default getFullAddress;
